import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

const linkStyles = css`
  color: ${(props) => props.theme.colors.text.link};
  text-decoration: underline;
`

export const ConversationRichTextLinkStyled = styled(Link)`
  ${linkStyles}
`

export const ConversationRichTextExternalLinkStyled = styled.a`
  ${linkStyles}
`
